const DEVICE_ID_KEY = 'billx_web_device_id';

export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }
  return deviceId;
};

export const getDeviceMetadata = () => {
  const ua = navigator.userAgent;
  let platform = 'Unknown';
  if (ua.includes('Mac')) platform = 'macOS';
  else if (ua.includes('Win')) platform = 'Windows';
  else if (ua.includes('Linux')) platform = 'Linux';

  let browser = 'Unknown';
  if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Safari')) browser = 'Safari';
  else if (ua.includes('Firefox')) browser = 'Firefox';

  return {
    type: 'web',
    platform,
    browser,
    model: `${platform} (${browser})`,
  };
};

export const getDeviceInfo = () => {
  return {
    deviceId: getDeviceId(),
    ...getDeviceMetadata(),
  };
};
